import {
  EventItem,
  StatusHistoryColorMode,
  StatusHistoryLabelGrouping,
  StatusHistoryPanelPropsBase,
  StatusHistoryPanelSpec,
} from '@/core';
import { BasePanelProps, PropToSpecMapping } from '@/plugin-system';

/**
 * Types for StatusHistory that are only used in the `Viz` variant.
 */
interface StatusHistoryPropsVizOnly {
  /**
   * Click handler for selected event
   */
  onEventClick?: (e: EventItem) => void;
}

export interface StatusHistoryProps extends BasePanelProps, StatusHistoryPanelPropsBase, StatusHistoryPropsVizOnly {
  /** mapSpecToProps delivers these as snake_case at runtime. */
  color_mode?: StatusHistoryColorMode;
  /** mapSpecToProps delivers these as snake_case at runtime. */
  label_grouping?: StatusHistoryLabelGrouping;
}

// TODO: can convert to camelCase here later if desired but leaving snake_case since nested label_grouping
// properties are snake_case and deep prop to spec mapping is awkward.
export const STATUS_HISTORY_PROP_TO_SPEC_MAPPING: PropToSpecMapping<StatusHistoryProps, StatusHistoryPanelSpec> = {
  color_mode: 'color_mode',
  label_grouping: 'label_grouping',
  thresholds: 'thresholds',
  unit: 'unit',
  visual: 'visual',
};

export const ROW_LABEL_WIDTH = 100;
export const ROW_SPACING = 8; // MUI spacing(1) = 8px, used between label and cells
export const AXIS_PLUS_LEGEND_HEIGHT = 65;
export const MAX_LABEL_WIDTH_FRACTION = 1 / 3;
export const LABEL_PADDING = 16;
export const ESTIMATED_CHAR_WIDTH_PX = 7;
